import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from 'src/guard/authGuard/auth.guard';
import { PermissionGuard } from 'src/guard/permission/permission-guard.guard';

const routes: Routes = [
  {
    path: 'login',
    loadChildren: () => import('./authentication/authentication.module').then(m => m.AuthenticationModule)
  },
  {
    path: 'home',
    canActivate: [AuthGuard],
    canLoad: [AuthGuard],
    loadChildren: () => import('./home/home.module').then(m => m.HomeModule),
    data: { slug: 'home' },
  },
  {
    path: 'calibration',
    canActivate: [AuthGuard, PermissionGuard],
    canLoad: [AuthGuard, PermissionGuard],
    loadChildren: () => import('./calibration/calibration.module').then(m => m.CalibrationModule),
    data: { slug: 'calibration' },
  },
  {
    path: 'verification',
    canActivate: [AuthGuard, PermissionGuard],
    canLoad: [AuthGuard, PermissionGuard],
    loadChildren: () => import('./verification/verification.module').then(m => m.VerificationModule),
    data: { slug: 'verification' },
  },
  {
    path: 'issue',
    canActivate: [AuthGuard],
    canLoad: [AuthGuard],
    loadChildren: () => import('./issue/issue.module').then(m => m.IssueModule),
  },
  {
    path: 'data-scrub',
    canActivate: [AuthGuard, PermissionGuard],
    canLoad: [AuthGuard, PermissionGuard],
    loadChildren: () => import('./data-scrub/data-scrub.module').then(m => m.DataScrubModule),
    data: { slug: 'data-scrub' },
  },
  {
    path: 'manage-sensor',
    canActivate: [AuthGuard, PermissionGuard],
    canLoad: [AuthGuard, PermissionGuard],
    loadChildren: () => import('./manage-sensor/manage-sensor.module').then(m => m.ManageSensorModule ),
    data: { slug: 'manage-sensor' },
  },
  {
    path: 'portal-logs',
    canActivate: [AuthGuard, PermissionGuard],
    canLoad: [AuthGuard, PermissionGuard],
    loadChildren: () => import('./portal-logs/portal-logs.module').then(m => m.PortalLogsModule ),
    data: { slug: 'portal-logs' },
  },
  {
    path: 'reason',
    canActivate: [AuthGuard],
    canLoad: [AuthGuard],
    loadChildren: () => import('./reason/reason.module').then(m => m.ReasonModule ),
    data: { slug: 'reason' },
  },
  { path: '**', redirectTo: '/login' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
